module.exports = __webpack_public_path__ + "static/img/notice.fba3c5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notice.svg
// module id = ahUb
// module chunks = 1